import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';
import moment from 'moment';
import { operationalFunction } from 'components/UIBuilder/SectionFunction/Common';
import CustomStatistic from 'components/CustomStatistic';

function isChecked(value) {
  return value === true || value === 1 || value === '1' || String(value).toLowerCase() === 'true';
}

// Job Detail 中任务完成后同步刷新 Job 信息，让 CompanyUserName 立即反映 Assigned Users 的变化。
function refreshJobDetail(pageComponent) {
  if (Number(pageComponent?.props?.authUser?.CompanyId) === 31) {
    // CompanyUserName 由 Job Section 数据提供，直接刷新该 Section。
    globalFunction.getSectionComponent(pageComponent, 'Job')?.getSectionDataByDefault();
  }
}

//通过 Status 和时间条件给 badge 的 BackgroundColor 赋值
export function formatData({ parameter } = {}) {
  let data = parameter.map((item, i) => {
    let iconFormat = [];
    if (item.Status === 2) {
      //如果 Status 是2, 设置绿背景色, actionType 是 UpdateStatus 的 图标设置用第2个图片
      item.BackgroundColor = config.color.success;
      iconFormat.push({ actionType: 'UpdateStatus', iconIndex: 1 });
    } else {
      if (globalFunction.formatDate(item.DueDate) <= new Date()) {
        //如果超时, 设置红背景色
        item.BackgroundColor = config.color.danger;
      } else {
        //设置默认背景色
        item.BackgroundColor = config.color.default;
      }
    }
    if (iconFormat.length > 0) item.IconFormat = iconFormat;
    return item;
  })
  return data;
}

//装载模板
export function loadTaskTemplate({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  if (parameter > 0) {
    httpClient
      .get('Admin/TaskTemplate/' + parameter)
      .then(({ data }) => {
        if (data.result) {
          let dueDate = new Date();
          let assignedUserIds = [];
          let assignedUserId = 0;
          let assignedTeamId = 0
          let roleList = data.data.AssignedToRoleList;
          if ((roleList === null || roleList === undefined || roleList.length === 0) && data.data.AssignedToRole) {
            roleList = data.data.AssignedToRole.split(',').map(r => r.trim()).filter(r => r);
          }
          if (roleList && roleList.length > 0) {
            roleList.forEach(role => {
              switch (role) {
                case 'Assigned User':
                  if (pageComponent.state.jobData.AssignedUserId !== null) {
                    assignedUserIds.push(pageComponent.state.jobData.AssignedUserId);
                    assignedUserId = pageComponent.state.jobData.AssignedUserId;
                  }
                  break;
                case 'Signoff User':
                  if (pageComponent.state.jobData.SignoffUserId !== null) {
                    assignedUserIds.push(pageComponent.state.jobData.SignoffUserId);
                    assignedUserId = pageComponent.state.jobData.SignoffUserId;
                  }
                  break;
                case 'Assessing User':
                  if (pageComponent.state.jobData.AssessingUserId !== null) {
                    assignedUserIds.push(pageComponent.state.jobData.AssessingUserId);
                    assignedUserId = pageComponent.state.jobData.AssessingUserId;
                  }
                  break;
                case 'Current User':
                  if (pageComponent.props.authUser?.CompanyUserId) {
                    assignedUserIds.push(pageComponent.props.authUser.CompanyUserId);
                    assignedUserId = pageComponent.props.authUser.CompanyUserId;
                  }
                  break;
                case 'Admin/Concierge User':
                  if (Number(pageComponent.props.authUser?.CompanyId) === 3) {
                    let CompanyUserList = pageComponent.state.jobData.CompanyUserList;
                    CompanyUserList.forEach(element => {
                      assignedUserIds.push(element.CompanyUserId);
                    });
                  }
                  break;
              }
            });
          }
          if (data.data.AssignedUserIds !== null && data.data.AssignedUserIds !== undefined) {
            assignedUserIds.push(...data.data.AssignedUserIds);
          }
          if (data.data.AssignedUserId !== null && data.data.AssignedUserId !== undefined) {
            assignedUserId = data.data.AssignedUserId;
          }
          //去重，避免多个角色指向同一用户时多选框出现重复标签
          assignedUserIds = [...new Set(assignedUserIds)];
          if (data.data.DaysBeforeDue !== null) {
            if (pageComponent.state.jobData.Company.TaskDueDayExcludeWeekend === true) {
              dueDate = globalFunction.addWorkingDays(dueDate, data.data.DaysBeforeDue);
            } else {
              dueDate = globalFunction.addDate(dueDate, data.data.DaysBeforeDue);
            }
          }
          assignedTeamId = data.data.AssignedTeamId === null ? 0 : data.data.AssignedTeamId;

          if (pageComponent.state.jobData.ModuleConfig.NewTaskAutoNotify === true) {
            sectionComponent.customForm.current?.formRef.current?.setFieldsValue({ Notify: true });
          } else {
            sectionComponent.customForm.current?.formRef.current?.setFieldsValue({ Notify: data.data.Notify });
          }
          // 先用 Task Template 原始值回填 checkbox，避免后续 mail merge 响应缺字段时丢失勾选状态。
          sectionComponent.customForm.current?.formRef.current?.setFieldsValue({
            NotifyAssignee: isChecked(data.data.NotifyAssignee),
            NotifyOffice: isChecked(data.data.NotifyOffice)
          });

          httpClient
            .get('Admin/TaskTemplate/GetMailMergeDetail?objId=' + parameter + '&parameterId=' + pageComponent.state.jobData.JobId + '&dataModelType=1')
            .then(({ data }) => {
              sectionComponent.customForm.current?.formRef.current?.setFieldsValue({ DueDate: moment(dueDate, config.format.date), AssignedUserIds: assignedUserIds, AssignedUserId: assignedUserId, AssignedTeamId: assignedTeamId, Description: data.data.Description, JobNote: globalFunction.convertToParagraphs(data.data.JobNote) });
            });

        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }
}

export function addJobTaskPopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie, data } = {}) {
  document.querySelector('.JobTaskForm #DueDate').click();
  getTaskPriorityIdDataSourceRun({ parameter, sectionComponent, pageComponent, sectionName, uie });
  sectionComponent.customForm.current?.formRef.current?.setFieldsValue({ Notify: pageComponent.state.jobData.ModuleConfig.NewTaskAutoNotify === true });
}

export function getTaskPriorityIdDataSourceRun({ parameter, sectionComponent, pageComponent, sectionName } = {}) {
  setTimeout(() => {
    let componentDataSource = { ...sectionComponent.customForm.current?.state.componentDataSource };
    if (componentDataSource.TaskPriorityId !== undefined && componentDataSource.TaskPriorityId !== null) {
      const result = componentDataSource.TaskPriorityId.find(
        item => item.Data && item.Data.Priority === 2
      );
      sectionComponent.customForm.current?.formRef.current?.setFieldsValue({ TaskPriorityId: result?.Value, Notify: true });
    }
  }, config.setTimeoutMilliSecond);
}

//设置已有的JobTaskDocument
export function editJobTaskPopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie, data } = {}) {
  pageComponent.setState({ selectedDocumentList: data.DocumentList });
}

//设置JobTaskDocument
export function setJobTaskDocument(documentId, pageComponent) {
  if (documentId !== 0) {
    httpClient
      .get('Business/Document/' + documentId)
      .then(({ data }) => {
        if (data.result) {
          let selectedDocumentList = pageComponent.state.selectedDocumentList;
          selectedDocumentList.push(data.data);
          pageComponent.setState({ selectedDocumentList });
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }
}

//点击前面的灰色√更改状态
export function updateStatus({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  if (parameter.Status !== 2) {
    globalFunction.confirm({
      content: 'Set the task to Complete?',
      okText: 'Confirm',
      callback: function () {
        httpClient
          .put('Business/JobTask/UpdateStatus', parameter)
          .then(({ data }) => {
            if (data.result) {
              refreshJobDetail(pageComponent);
              setTimeout(() => {
                sectionComponent.getSectionDataByDefault();
              }, config.setTimeoutMilliSecond);
            } else {
              globalFunction.handleResultError(data, pageComponent);
            }
          })
          .catch(function (error) {
            globalFunction.handleError(error, pageComponent);
          });
      }
    });
  }
}

export function updateStatusNoConfirm({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  console.log(parameter, '------')
  if (parameter.Status !== 2) {
    httpClient
      .put('Business/JobTask/UpdateStatus', parameter)
      .then(({ data }) => {
        if (data.result) {
          refreshJobDetail(pageComponent);
          setTimeout(() => {
            sectionComponent.getSectionDataByDefault();
          }, config.setTimeoutMilliSecond);
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }
}

//删除前录入删除原因
export function deleteBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  pageComponent.setState({ deleteJobTaskShow: true });
  setTimeout(() => {
    pageComponent.deleteJobTask.current?.setState({ jobTask: parameter });
    pageComponent.deleteJobTask.current?.deleteJobTaskFormRef.current?.setFieldsValue({ DeleteReason: null });
  }, config.setTimeoutMilliSecond);
}

//打开 JobTask 的回收站
export function openRecycleBin({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  pageComponent.setState({ jobTaskRecycleBinShow: true });
  let searchParameter = { ...sectionComponent.state.searchParameter };
  let jobId = sectionComponent.props.searchParameter.jobId;
  httpClient
    .get('/Business/JobTask/GetRecycleBinList?jobId=' + jobId)
    .then(({ data }) => {
      if (data.result) {
        data.data = formatData({ parameter: data.data });
        pageComponent.jobTaskRecycleBin.current?.setState({ data: data.data, selectedRowKeys: [] });
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

//Dashboard - 点击前面的灰色√更改状态
export function updateStatusDashboard({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  if (parameter.Status !== 2) {
    globalFunction.confirm({
      content: 'Set the task to Complete?',
      okText: 'Confirm',
      callback: function () {
        httpClient
          .put('Business/JobTask/UpdateStatus', parameter)
          .then(({ data }) => {
            if (data.result) {
              refreshJobDetail(pageComponent);
              setTimeout(() => {
                sectionComponent.getSectionDataByDefault();
                sectionComponent.getTodayTaskCounter();
                sectionComponent.getTomorrowTaskCounter();
                sectionComponent.getOverdueTaskCounter();
              }, config.setTimeoutMilliSecond);
            } else {
              globalFunction.handleResultError(data, pageComponent);
            }
          })
          .catch(function (error) {
            globalFunction.handleError(error, pageComponent);
          });
      }
    });
  }
}

export function updateStatusDashboardNoConfirm({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  httpClient
    .put('Business/JobTask/UpdateStatus', parameter)
    .then(({ data }) => {
      if (data.result) {
        refreshJobDetail(pageComponent);
        setTimeout(() => {
          sectionComponent.getSectionDataByDefault();
          sectionComponent.getTodayTaskCounter();
          sectionComponent.getTomorrowTaskCounter();
          sectionComponent.getOverdueTaskCounter();
        }, config.setTimeoutMilliSecond);
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

// My Tasks 右侧 Job Status 徽标右键菜单
export function showJobWorkflowStatusMenuDashboard({ e, targetRect, parameter, sectionComponent, pageComponent } = {}) {
  e?.preventDefault?.();
  const moduleId = Number(parameter.Job?.ModuleId ?? parameter.Job_ModuleId ?? parameter.ModuleId);
  // 记录右键坐标；触屏长按没有鼠标事件时，使用徽标左上角作为菜单起点。
  const rect = targetRect ?? e.currentTarget.getBoundingClientRect();
  const menuPosition = {
    x: e?.clientX ?? rect.left,
    y: e?.clientY ?? rect.top,
  };
  // 状态已在页面初始化时预加载；若用户在预加载完成前右键，暂时显示 loading。
  const jobWorkflowStatusByModuleId = sectionComponent.state.jobWorkflowStatusByModuleId ?? {};
  sectionComponent.setState({
    jobWorkflowStatusList: jobWorkflowStatusByModuleId[moduleId] ?? [],
    jobWorkflowStatusMenuLoading: sectionComponent.state.jobWorkflowStatusLoading === true,
    jobWorkflowStatusMenuShow: true,
    jobWorkflowStatusMenuPosition: menuPosition,
    jobWorkflowStatusMenuJobId: parameter.JobId,
    jobWorkflowStatusMenuModuleId: moduleId,
  });
  if (!Number.isInteger(moduleId) || moduleId <= 0) {
    sectionComponent.setState({ jobWorkflowStatusList: [], jobWorkflowStatusMenuLoading: false });
    message.error('Unable to determine the module for this job.');
    return false;
  }
  sectionComponent.setState({ jobWorkflowStatusList: jobWorkflowStatusByModuleId[moduleId] ?? [] });
  return false;
}

// 页面进入时按 Module 预加载状态；右键菜单只从本地缓存筛选，不再发状态请求。
export function loadJobWorkflowStatuses({ sectionComponent, pageComponent } = {}) {
  sectionComponent.setState({ jobWorkflowStatusLoading: true });
  httpClient.get('Admin/WorkflowStatus/GetList?moduleId=0')
    .then(({ data }) => {
      if (!data.result) {
        sectionComponent.setState({ jobWorkflowStatusLoading: false, jobWorkflowStatusMenuLoading: false });
        globalFunction.handleResultError(data, pageComponent);
        return;
      }
      // 后端从认证上下文限制 CompanyId；页面缓存时按每条状态的 ModuleId 分组。
      const jobWorkflowStatusByModuleId = (data.data ?? []).reduce((lookup, status) => {
        const moduleId = Number(status.ModuleId ?? status.moduleId);
        const value = Number(status.WorkflowStatusId ?? status.workflowStatusId);
        const key = status.Name ?? status.name;
        if (Number.isInteger(moduleId) && moduleId > 0 && value > 0 && key) {
          if (!lookup[moduleId]) lookup[moduleId] = [];
          lookup[moduleId].push({
            Key: key,
            Value: value,
            Color: status.BackgroundColor ?? status.backgroundColor,
          });
        }
        return lookup;
      }, {});
      sectionComponent.setState({
        jobWorkflowStatusByModuleId,
        jobWorkflowStatusLoading: false,
        ...(sectionComponent.state.jobWorkflowStatusMenuShow ? {
          jobWorkflowStatusList: jobWorkflowStatusByModuleId[sectionComponent.state.jobWorkflowStatusMenuModuleId] ?? [],
          jobWorkflowStatusMenuLoading: false,
        } : {}),
      });
    })
    .catch(error => {
      sectionComponent.setState({ jobWorkflowStatusLoading: false, jobWorkflowStatusMenuLoading: false });
      globalFunction.handleError(error, pageComponent);
    });
}

// 选择并确认后复用 Job 既有的状态变更接口；该接口会新增 job_status_change 记录。
export function changeJobWorkflowStatusDashboard({ parameter, sectionComponent, pageComponent } = {}) {
  globalFunction.confirm({
    content: 'Set the job status to ' + parameter.StatusName + '?',
    okText: 'Confirm',
    callback: function () {
      httpClient
        .put('Business/Job/ChangeWorkflowStatus', parameter)
        .then(({ data }) => {
          if (data.result) {
            sectionComponent.setState({ jobWorkflowStatusMenuShow: false });
            setTimeout(() => {
              sectionComponent.getSectionDataByDefault();
              // Dashboard 有日期统计卡片；普通 /task 页面只刷新表格。
              sectionComponent.getTodayTaskCounter?.();
              sectionComponent.getTomorrowTaskCounter?.();
              sectionComponent.getOverdueTaskCounter?.();
            }, config.setTimeoutMilliSecond);
          } else {
            globalFunction.handleResultError(data, pageComponent);
          }
        })
        .catch(error => globalFunction.handleError(error, pageComponent));
    }
  });
}

// /task 的 Priority 右键菜单从页面初始化时加载的公司级优先级列表中取值。
export function showTaskPriorityMenu({ e, targetRect, parameter, sectionComponent } = {}) {
  e?.preventDefault?.();
  const rect = targetRect ?? e.currentTarget.getBoundingClientRect();
  sectionComponent.setState({
    taskPriorityMenuPosition: { x: e?.clientX ?? rect.left, y: e?.clientY ?? rect.top },
    taskPriorityMenuTaskId: parameter.JobTaskId ?? parameter.key,
    taskPriorityMenuShow: true,
    taskPriorityMenuLoading: sectionComponent.state.taskPriorityLoading === true,
  });
  return false;
}

export function changeTaskPriority({ taskPriorityId, priorityName, sectionComponent, pageComponent } = {}) {
  globalFunction.confirm({
    content: taskPriorityId == null
      ? 'Remove the task priority?'
      : 'Set the task priority to ' + priorityName + '?',
    okText: 'Confirm',
    callback: function () {
      httpClient.put('Business/JobTask/UpdatePriority', {
        key: sectionComponent.state.taskPriorityMenuTaskId,
        TaskPriorityId: taskPriorityId,
      })
        .then(({ data }) => {
          if (data.result) {
            sectionComponent.setState({ taskPriorityMenuShow: false });
            setTimeout(() => sectionComponent.getSectionDataByDefault(), config.setTimeoutMilliSecond);
          } else {
            globalFunction.handleResultError(data, pageComponent);
          }
        })
        .catch(error => globalFunction.handleError(error, pageComponent));
    }
  });
}

export function taskToday({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.child.map((section, i) => {
    if (section.current?.props.parameter.id === sectionComponent.props.parameter.id) {
      let searchParameter = {};
      searchParameter.Type = 'Today';
      searchParameter.PersonalOnly = section.current?.state.personalOnly;
      searchParameter.IsCompleted = section.current?.state.isCompleted;
      section.current?.setState({ searchParameter, startDate: moment(), endDate: moment() });

      setTimeout(() => {
        section.current?.getSectionDataByDefault();
      }, config.setTimeoutMilliSecond);
    }
  })
}

export function taskTomorrow({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.child.map((section, i) => {
    if (section.current?.props.parameter.id === sectionComponent.props.parameter.id) {
      let searchParameter = {};
      searchParameter.Type = 'Tomorrow';
      searchParameter.PersonalOnly = section.current?.state.personalOnly;
      searchParameter.IsCompleted = section.current?.state.isCompleted;
      section.current?.setState({ searchParameter, startDate: moment().add(1, 'days'), endDate: moment().add(1, 'days') });

      setTimeout(() => {
        section.current?.getSectionDataByDefault();
      }, config.setTimeoutMilliSecond);
    }
  })
}

export function taskOverdue({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.child.map((section, i) => {
    if (section.current?.props.parameter.id === sectionComponent.props.parameter.id) {
      let searchParameter = {};
      searchParameter.Type = 'Overdue';
      searchParameter.PersonalOnly = section.current?.state.personalOnly;
      searchParameter.IsCompleted = section.current?.state.isCompleted;
      section.current?.setState({ searchParameter, startDate: moment(), endDate: moment() });

      setTimeout(() => {
        section.current?.getSectionDataByDefault();
      }, config.setTimeoutMilliSecond);
    }
  })
}

//TaskPaging 上的编辑
export function editByTaskPaging({ parameter, sections, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({ dataLoading: true });
  sectionComponent.setState({ showModal: true, componentType: 'Edit' });
  pageComponent.setState({ selectedDocumentList: [] });
  setTimeout(() => {
    //先获取数据
    setTimeout(() => {
      sectionComponent.customForm.current?.setState({ autoLoadComponentDataSource: false });
      sectionComponent.customForm.current?.getComponentDataSource();
      httpClient
        .get(pageComponent.props.areaName + '/' + sectionName + '/' + parameter.key)
        .then(({ data }) => {
          if (data.result) {
            //处理不适合antd组件的数据
            let componentDataSource = sectionComponent.customForm.current?.state.componentDataSource;
            sectionComponent.props.section.componentList.filter(c => c.type === 'Edit')[0].groupList.forEach(group => {
              group.uieList.forEach(uie => {
                switch (uie.component) {
                  case 'DatePicker':
                    //处理日期, 把字符串转成moment
                    if (data.data[uie.source] !== null && data.data[uie.source] !== undefined) {
                      data.data[uie.source] = moment(data.data[uie.source], config.format.date);
                    } else {
                      data.data[uie.source] = undefined;
                    }
                    break;
                  case 'Select':
                    //处理Select默认选项, 如果字段的值是null且备选项列表已加载, 则自动选择备选项里第一个(如果已有数据, 则加载备选项里有的那一条)
                    if ((data.data[uie.source] === null || data.data[uie.source] === undefined) && componentDataSource[uie.source] !== undefined) {
                      if (uie.type === null || uie.type.indexOf('multiple') < 0) {
                        data.data[uie.source] = componentDataSource[uie.source][0].Value;
                      }
                      if (uie.type !== null && uie.type.indexOf('multiple') >= 0) {
                        data.data[uie.source] = [];
                      }
                    }
                    if (uie.autoSelect) {
                      //如果是自定义AutoSelect的类型, 触发其onChange事件
                      operationalFunction({ functionName: uie.onChange, sectionName: sectionName, parameter: data.data[uie.source], formComponent: sectionComponent.customForm.current, sectionComponent: sectionComponent, pageComponent: pageComponent, uie: uie });
                    }
                    break;
                }
              });
            });
            //把处理后的数据赋值给表单
            sectionComponent.customForm.current?.formRef.current?.setFieldsValue(data.data);
            sectionComponent.customForm.current?.setState({ formData: data.data, currentDataKey: data.data.key });
            sectionComponent.setState({ dataLoading: false });
            pageComponent.setState({ jobId: data.data.JobId, moduleId: data.data.Job_ModuleId });
            editJobTaskPopUpRun({ parameter: parameter, sectionComponent: sectionComponent, pageComponent: pageComponent, sectionName: sectionName, uie: uie, data: data.data });
            sectionComponent.setState({ isFormModified: false });
          } else {
            globalFunction.handleResultError(data, pageComponent);
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
        });
    }, config.setTimeoutMilliSecond);
  }, config.setTimeoutMilliSecond);
}

//点击copyFromDescription
export function copyFromDescription({ parameter, sections, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.customForm.current?.formRef.current?.setFieldsValue({ JobNote: globalFunction.convertToParagraphs(sectionComponent.customForm.current?.formRef.current?.getFieldValue('Description')) });
}

export function addSubmitFinish({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  globalFunction.getSectionComponent(pageComponent, 'Job')?.getSectionDataByDefault();
  globalFunction.getSectionComponent(pageComponent, 'JobNote')?.getSectionDataByDefault();
  globalFunction.getSectionComponent(pageComponent, 'JobStatusChange')?.getSectionDataByDefault();
}

export function loadNoteTemplate({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  if (parameter > 0) {
    const jobId = pageComponent?.state?.jobData?.JobId ?? sectionComponent?.props?.searchParameter?.jobId;
    // Job 详情中按 Email Template 的方式执行 MailMerge；无 Job 上下文时保留原有模板装载行为。
    const url = jobId ? 'Admin/NoteTemplate/GetMailMergeDetail/' + parameter + '?jobId=' + jobId : 'Admin/NoteTemplate/' + parameter;
    httpClient
      .get(url)
      .then(({ data }) => {
        if (data.result) {
          sectionComponent.customForm.current?.formRef.current?.setFieldsValue({ JobNote: data.data.Content });
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }
}

//MyJobTask 上的编辑
export function editByMyJobTask({ parameter, sections, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({ dataLoading: true });
  sectionComponent.setState({ showModal: true, componentType: 'Edit' });

  setTimeout(() => {
    //先获取数据
    setTimeout(() => {
      sectionComponent.customForm.current?.setState({ autoLoadComponentDataSource: false });
      sectionComponent.customForm.current?.getComponentDataSource();
      httpClient
        .get('Business/JobTask/' + parameter.key)
        .then(({ data }) => {
          if (data.result) {
            //处理不适合antd组件的数据
            let componentDataSource = sectionComponent.customForm.current?.state.componentDataSource;
            sectionComponent.state.section.componentList.filter(c => c.type === 'Edit')[0].groupList.forEach(group => {
              group.uieList.forEach(uie => {
                switch (uie.component) {
                  case 'DatePicker':
                    //处理日期, 把字符串转成moment
                    if (data.data[uie.source] !== null && data.data[uie.source] !== undefined) {
                      data.data[uie.source] = moment(data.data[uie.source], config.format.date);
                    } else {
                      data.data[uie.source] = undefined;
                    }
                    break;
                  case 'Select':
                    //处理Select默认选项, 如果字段的值是null且备选项列表已加载, 则自动选择备选项里第一个(如果已有数据, 则加载备选项里有的那一条)
                    if ((data.data[uie.source] === null || data.data[uie.source] === undefined) && componentDataSource[uie.source] !== undefined) {
                      if (uie.type === null || uie.type.indexOf('multiple') < 0) {
                        data.data[uie.source] = componentDataSource[uie.source][0].Value;
                      }
                      if (uie.type !== null && uie.type.indexOf('multiple') >= 0) {
                        data.data[uie.source] = [];
                      }
                    }
                    if (uie.autoSelect) {
                      //如果是自定义AutoSelect的类型, 触发其onChange事件
                      operationalFunction({ functionName: uie.onChange, sectionName: sectionName, parameter: data.data[uie.source], formComponent: sectionComponent.customForm.current, sectionComponent: sectionComponent, pageComponent: pageComponent, uie: uie });
                    }
                    break;
                }
              });
            });
            //把处理后的数据赋值给表单
            sectionComponent.customForm.current?.formRef.current?.setFieldsValue(data.data);
            sectionComponent.customForm.current?.setState({ formData: data.data, currentDataKey: data.data.key });
            sectionComponent.setState({ dataLoading: false });
            pageComponent.setState({ jobId: data.data.JobId, moduleId: data.data.Job_ModuleId });
            editJobTaskPopUpRun({ parameter: parameter, sectionComponent: sectionComponent, pageComponent: pageComponent, sectionName: sectionName, uie: uie, data: data.data });
            sectionComponent.setState({ isFormModified: false });
          } else {
            globalFunction.handleResultError(data, pageComponent);
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
        });
    }, config.setTimeoutMilliSecond);
  }, config.setTimeoutMilliSecond);
}

export function submitCustomForm({ parameter, sectionComponent, pageComponent, sectionName } = {}) {
  sectionComponent.customForm.current?.submitForm();
}

export function customFormOnSubmit({ parameter, formComponent, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({ customFormSubmitting: true });
  let areaName = 'Business';
  let pageName = 'JobTask';
  let form = formComponent.formRef.current?.getFieldsValue();

  switch (sectionName) {
    case 'JobTask':
      //判断Task必须选了user或者team
      if ((form.AssignedUserId === undefined || form.AssignedUserId === 0) && (form.AssignedUserIds === undefined || form.AssignedUserIds.length === 0) && (form.AssignedTeamId === undefined || form.AssignedTeamId === 0)) {
        message.error('Please assign the task to a user or a team.');
        sectionComponent.setState({ customFormSubmitting: false });
        return false;
      }
      //追加选择的Document
      form.DocumentList = pageComponent.state.selectedDocumentList;
      break;
  }

  formComponent.props.component.groupList.filter(c => c.show).forEach(group => {
    group.uieList.forEach(uie => {
      if (uie.component === 'DatePicker') {
        if (form[uie.source] !== undefined && form[uie.source] !== null) {
          form[uie.source] = moment(form[uie.source]).format(config.format.sqlDate);
        } else {
          form[uie.source] = null;
        }
      }
    });
  });

  if (parameter !== undefined) {
    for (let key in parameter) {
      form[key] = parameter[key];
    }
  }

  //处理一些特殊的自定义字段
  form['Notify'] = formComponent.formRef.current?.getFieldValue('Notify');

  form.key = formComponent.state.currentDataKey;
  console.log(sectionComponent.state.componentType + ' 提交的表单', form);

  switch (sectionComponent.state.componentType) {
    case 'Create':
      httpClient
        .post(areaName + '/' + sectionName, form)
        .then(({ data }) => {
          if (data.result) {
            customFormFinish({ data: data.data, parameter: parameter, formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, sectionName: sectionName, uie: uie });
            if (data.code === 2) {
              message.info(data.message);
            }
          } else {
            if (data.code === 2) {
              message.error(data.message);
              sectionComponent.setState({ customFormSubmitting: false });
            } else {
              globalFunction.handleResultError(data, pageComponent);
              sectionComponent.setState({ customFormSubmitting: false });
            }
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
          sectionComponent.setState({ customFormSubmitting: false });
        });
      break;
    case 'Edit':
      httpClient
        .put(areaName + '/' + sectionName, form)
        .then(({ data }) => {
          if (data.result) {
            if (sectionName === 'JobTask') {
              refreshJobDetail(pageComponent);
            }
            customFormFinish({ data: data.data, parameter: parameter, formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, sectionName: sectionName, uie: uie });
            if (data.code === 2) {
              message.info(data.message);
            }
          } else {
            if (data.code === 2) {
              message.error(data.message);
              sectionComponent.setState({ customFormSubmitting: false });
            } else {
              globalFunction.handleResultError(data, pageComponent);
              sectionComponent.setState({ customFormSubmitting: false });
            }
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
          sectionComponent.setState({ customFormSubmitting: false });
        });
      break;
  }
}

function customFormFinish({ data, parameter, formComponent, sectionComponent, pageComponent, sectionName, uie } = {}) {
  switch (sectionComponent.state.componentType) {
    case 'Create':
      addSubmitFinish({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie });
      break;
    case 'Edit':
      break;
  }

  console.log(sectionComponent);

  sectionComponent.setState({ customFormSubmitting: false });
  setTimeout(() => {
    if (sectionComponent.state.closeModelAfterSubmit !== false) {
      formComponent.resetFields();
      sectionComponent.setState({ showModal: false });
    }
    setTimeout(() => {
      sectionComponent.getSectionDataByDefault();
      formComponent.resetFields();
      if (sectionComponent.state.closeModelAfterSubmit !== false) {
        sectionComponent.setState({ componentType: null });
      } else {
      }
    }, config.setTimeoutMilliSecond);
  }, config.setTimeoutMilliSecond);
}
